import React, { Component, createRef } from "react";
import Select from "react-select";
import OrganizationRowData from "../table-data/organization-row";
import AddmemberModal from "../../modals/add-member-modal/add-member-modal";
import ConfirmModal from "../../modals/ConfirmModal";
import {
    deleteOrganization,
    GetAllOrganizations,
    ExportAllOrganizations,
    ExportOrganizationEmails,
} from "../../../api";
import ReactPaginate from "react-paginate";
import SelectDropDown from "../../shared/drop-down/drop-down";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button } from "react-bootstrap";
import { Form, Col, Row } from "react-bootstrap";
import "./../organization-page/organization-page.scss";
const fileDownload = require("js-file-download");

class OrganizationsPage extends Component {
    typingTimer = null;
    constructor(props) {
        super(props);
        this.state = {
            show_spinner: false,
            isPcAdmin: props.isPcAdmin,
            listOrganizations: props.listOrganizations,
            organization_id: "",
            user: props.user,
            showAddMember: false,
            showConfirmModel: false,
            confirmText: "You want to delete this organization!",
            pageCount: Math.ceil(props.totalOrganization / 1),
            sortBy: "id",
            sortValue: "ASC",
            page: 1,
            timeout: 5,
            filterMainAdmin: null,
            filterRM: null,
            filterByActivity: "",
            searchTerm: "",
            filterLeadOwner: "",
            typeFilterArrow: false,
            type: "",
            activityArrow: false,
            is_modal: false,
            org_emails: "",
            filterRMName: "",
            menuCLose: true,
        };
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleAdminSelectChange = this.handleAdminSelectChange.bind(this);
        this.tableRef = React.createRef();
    }

    componentDidUpdate() {
        if (
            this.state.listOrganizations.length !==
            this.props.listOrganizations.length
        ) {
            this.setState({
                isPcAdmin: this.props.isPcAdmin,
                listOrganizations: this.props.listOrganizations,
                pageCount: Math.ceil(this.props.totalOrganization / 10),
            });
        }
    }

    componentDidMount() {
        setInterval(() => {
            this.setState({
                timeout: this.state.timeout - 1,
            });
        }, 1000);
    }

    handleSearchChange(evt) {
        const serachValue = evt.currentTarget.value;
        //this.props.handleSearchEvent(serachValue)
        this.setState({
            searchTerm: serachValue,
        });
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
            this.fetchOrgs();
        }, 500);
    }

    handleKeyPress(evt) {
        if (evt.key === "Enter") {
            evt.preventDefault();
        }
    }
    deleteOrganization = (organization_id) => {
        deleteOrganization(organization_id)
            .then((response) => {
                if (response.success) {
                    this.props.updateOrganizations();
                    this.setState({ showConfirmModel: false });
                } else {
                    console.log(response.message);
                }
            })
            .catch((error) => console.log(error));
    };
    handlePageClick = (data) => {
        let selected = data.selected;
        this.setState({ page: selected + 1 }, () => {
            this.fetchOrgs();
        });
        this.tableRef.current.scrollTop = 0;
    };

    sortData = (SortBy) => {
        let SortValue = this.state.sortValue;
        if (this.state.sortBy == SortBy) {
            SortValue = SortValue == "DESC" ? "ASC" : "DESC";
        } else {
            SortValue = "ASC";
        }

        this.setState(
            {
                sortBy: SortBy,
                sortValue: SortValue,
            },
            function () {
                this.fetchOrgs();
            },
        );
    };
    onExportCSVHandler = () => {
        this.setState({
            show_spinner: true,
        });
        let data = {
            sortBy: this.state.sortBy,
            sortValue: this.state.sortValue,
            filterMainAdmin: this.state.filterMainAdmin,
            filterRM: this.state.filterRM,
            searchTerm: this.state.searchTerm,
            type: this.state.type,
            filterByActivity: this.state.filterByActivity
                ? parseInt(this.state.filterByActivity)
                : "",
            filterLeadOwner: this.state.filterLeadOwner,
        };
        ExportAllOrganizations(data)
            .then((res) => {
                fileDownload(res, "organizations.csv");
                this.setState({
                    show_spinner: false,
                });
            })
            .catch((error) => {
                this.setState({
                    show_spinner: false,
                });
            });
    };

    onExportEmailsHandler = () => {
        this.setState({
            show_spinner: true,
            is_modal: true,
        });
        let data = {
            filterRM: this.state.filterRM,
        };
        ExportOrganizationEmails(data)
            .then((res) => {
                this.setState({
                    org_emails: res.data,
                });
                this.setState({
                    filterRMName: document.querySelector(
                        "select#relationship-manager",
                    ).selectedOptions[0].text,
                    show_spinner: false,
                });
            })
            .catch((error) => {
                this.setState({
                    show_spinner: false,
                });
            });
    };

    copyToClipboard = () => {
        this.textArea.select();
        document.execCommand("copy");
    };

    fetchOrgs = () => {
        let data = {
            sortBy: this.state.sortBy,
            sortValue: this.state.sortValue,
            filterMainAdmin: this.state?.filterMainAdmin?.value,
            filterRM: this.state.filterRM?.value,
            searchTerm: this.state.searchTerm,
            type: this.state.type,
            filterByActivity: this.state.filterByActivity
                ? parseInt(this.state.filterByActivity)
                : "",
            filterLeadOwner: this.state.filterLeadOwner,
        };
        GetAllOrganizations(this.state.page, data).then((res) => {
            this.props.updateOrganizationsList(res);
        });
    };

    handleSelectChange = (selectedOption) => {
        this.setState({ filterRM: selectedOption, page: 1 }, () => {
            this.fetchOrgs();
        });
    };

    handleAdminSelectChange = (selectedOption) => {
        this.setState({ filterMainAdmin: selectedOption, page: 1 }, () => {
            this.fetchOrgs();
        });
    };

    render() {
        const {
            organization_id,
            showAddMember,
            user,
            showConfirmModel,
            confirmText,
            pageCount,
            isPcAdmin,
            sortBy,
            sortValue,
            show_spinner,
            filterRM,
            is_modal,
            org_emails,
            filterRMName,
            menuCLose,
            filterMainAdmin,
        } = this.state;
        const { listOrganizations, totalOrganization, listLeadOwner } =
            this.props;
        let options = this.props.orgUsers.map((item) => {
            return {
                label: item.name,
                value: item.id,
            };
        });
        options = [{ label: "All", value: "" }, ...options];
        const orgTypeOptions = [
            { label: "All", value: "" },
            { label: "Agent", value: "hands_on" },
            { label: "Referral Partner", value: "hands_off" },
        ];
        let activityFilterOptions = [
            { label: "All", value: "" },
            { label: "0-30 DAYS", value: "30" },
            { label: "31-60 DAYS", value: "60" },
            { label: "61-90 DAYS", value: "90" },
            { label: "91-270 DAYS", value: "270" },
            { label: "271-365 DAYS", value: "365" },
            { label: "365+ DAYS", value: "20000" },
        ];
        const leadOwner = listLeadOwner.map((item) => ({
            label: item.name,
            value: item.id,
        }));
        return (
            <div className="org-page  page-bottom-wrap edit-organization">
                {showAddMember && (
                    <AddmemberModal
                        selectedMember={undefined}
                        organization_id={organization_id}
                        addNewMembers={(evt) => {
                            this.props.updateMembers();
                            this.setState({ showAddMember: false });
                        }}
                        handleClose={() =>
                            this.setState({ showAddMember: false })
                        }
                        show={showAddMember}
                    />
                )}
                {showConfirmModel && (
                    <ConfirmModal
                        organization_id={organization_id}
                        showConfirmModel={(evt) => {
                            this.setState({ showConfirmModel: false });
                        }}
                        handleClose={() =>
                            this.setState({ showConfirmModel: false })
                        }
                        show={showConfirmModel}
                        confirmText={confirmText}
                        handleConfirm={(e) =>
                            this.deleteOrganization(organization_id)
                        }
                    />
                )}
                {show_spinner ? (
                    <div className="loader-wrap">
                        <p className="loader"></p>
                    </div>
                ) : (
                    ""
                )}
                <div className="container-fluid payment-org">
                    <div
                        className="panel-heading override-panel-heading"
                        id="pannel-headingId"
                    >
                        <div className="d-flex panel-section">
                            <h4 className="org-title">
                                Organizations
                                <span>
                                    {"(" + this.props.totalOrganization + ")"}
                                </span>
                            </h4>
                            <div>
                                {(isPcAdmin || this.props.is_ems_pc_admin) && (
                                    <button
                                        onClick={(evt) =>
                                            this.props.showOrganizationModal(
                                                true,
                                            )
                                        }
                                        className="orgbtn override-orgbtn"
                                    >
                                        <i className="fa fa-create"></i> Add
                                        organization
                                    </button>
                                )}
                                {isPcAdmin && (
                                    <button
                                        onClick={(evt) =>
                                            this.props.showReportModal(true)
                                        }
                                        className="orgbtn override-orgbtn"
                                    >
                                        <i className="fa fa-create"></i> Reports
                                    </button>
                                )}
                                {isPcAdmin && (
                                    <button
                                        onClick={(evt) =>
                                            this.props.showAddResidualMassUploadsModal(
                                                true,
                                            )
                                        }
                                        className="orgbtn override-orgbtn"
                                    >
                                        <i className="fa fa-create"></i> Mass
                                        Residual Upload
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="header-search override-header-search">
                            {isPcAdmin && filterRM && (
                                <i
                                    className="fa fa-envelope pointer"
                                    style={{ marginRight: "1.5em" }}
                                    onClick={this.onExportEmailsHandler}
                                />
                            )}
                            {isPcAdmin && (
                                <i
                                    className="fa fa-download pointer"
                                    style={{ marginRight: "1.5em" }}
                                    onClick={this.onExportCSVHandler}
                                />
                            )}
                            <form>
                                <input
                                    onKeyPress={(evt) =>
                                        this.handleKeyPress(evt)
                                    }
                                    onChange={(evt) =>
                                        this.handleSearchChange(evt)
                                    }
                                    type="text"
                                    placeholder="Search Organizations"
                                    name="search"
                                    className="search-box"
                                />
                                <button type="button">
                                    <i className="fa fa-search"></i>
                                </button>
                            </form>
                        </div>
                    </div>
                    <div className="organization-filter-block">
                        <Row>
                            <Col xs={2} sm={4} md={4} lg={2} xl={2} xxl={2}>
                                <div className="relationship-select-area">
                                    <Select
                                        id="relationship-manager"
                                        className={
                                            menuCLose
                                                ? "relationship-select custom-slect bannkmodalselect"
                                                : "relationship-select active-slect"
                                        }
                                        options={options}
                                        onChange={this.handleAdminSelectChange}
                                        value={filterMainAdmin}
                                        placeholder="Select Main Admin"
                                        onMenuClose={(e) =>
                                            this.setState({ menuCLose: true })
                                        }
                                        onMenuOpen={(e) =>
                                            this.setState({ menuCLose: false })
                                        }
                                    />
                                </div>
                            </Col>
                            <Col xs={2} sm={4} md={4} lg={2} xl={2} xxl={2}>
                                <div className="relationship-select-area">
                                    <Select
                                        id="relationship-manager"
                                        className={
                                            menuCLose
                                                ? "relationship-select custom-slect bannkmodalselect"
                                                : "relationship-select active-slect"
                                        }
                                        options={options}
                                        onChange={this.handleSelectChange}
                                        value={filterRM}
                                        placeholder="Select Team Lead"
                                        onMenuClose={(e) =>
                                            this.setState({ menuCLose: true })
                                        }
                                        onMenuOpen={(e) =>
                                            this.setState({ menuCLose: false })
                                        }
                                    />
                                </div>
                            </Col>
                            <Col xs={2} sm={4} md={4} lg={2} xl={2} xxl={2}>
                                <div className="relationship-select-area">
                                    <Select
                                        className="relationship-select"
                                        options={activityFilterOptions}
                                        onChange={(value) => {
                                            this.setState(
                                                {
                                                    filterByActivity:
                                                        value?.value,
                                                    activityArrow:
                                                        !this.state
                                                            .activityArrow,
                                                    page: 1,
                                                },
                                                () => {
                                                    this.fetchOrgs();
                                                },
                                            );
                                        }}
                                    ></Select>
                                </div>
                            </Col>
                            <Col xs={2} sm={4} md={4} lg={2} xl={2} xxl={2}>
                                <div className="relationship-select-area leadOwnerDrop">
                                    <SelectDropDown
                                        className="relationship-select"
                                        options={leadOwner}
                                        handleChange={(value) => {
                                            console.log(value);
                                            this.setState(
                                                {
                                                    filterLeadOwner:
                                                        value?.value,
                                                    page: 1,
                                                },
                                                () => {
                                                    this.fetchOrgs();
                                                },
                                            );
                                        }}
                                        placeholder="Select Lead Owner"
                                        clearValue={Boolean(
                                            this.state.filterLeadOwner,
                                        )}
                                    ></SelectDropDown>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="table-organizations" ref={this.tableRef}>
                        <table
                            className="table  table-responsive"
                            id="organization-index-table"
                        >
                            <thead>
                                <tr>
                                    <th
                                        style={{ whiteSpace: "nowrap" }}
                                        onClick={(e) => this.sortData("id")}
                                        className="thId"
                                    >
                                        ID
                                        {sortBy === "id" && (
                                            <i
                                                className={
                                                    sortValue === "ASC"
                                                        ? "fa fa-arrow-up"
                                                        : "fa fa-arrow-down"
                                                }
                                                aria-hidden="true"
                                            />
                                        )}
                                    </th>
                                    <th className="logohead"></th>
                                    <th
                                        style={{ whiteSpace: "nowrap" }}
                                        onClick={(e) => this.sortData("name")}
                                        className="thOrgName"
                                    >
                                        Organization name
                                        {sortBy === "name" && (
                                            <i
                                                className={
                                                    sortValue === "ASC"
                                                        ? "fa fa-arrow-up"
                                                        : "fa fa-arrow-down"
                                                }
                                                aria-hidden="true"
                                            />
                                        )}
                                    </th>
                                    <th
                                        style={{ whiteSpace: "nowrap" }}
                                        onClick={(e) =>
                                            this.sortData("leads_last_month")
                                        }
                                    >
                                        Leads(Last Month)
                                        {sortBy === "leads_last_month" && (
                                            <i
                                                className={
                                                    sortValue === "ASC"
                                                        ? "fa fa-arrow-up"
                                                        : "fa fa-arrow-down"
                                                }
                                                aria-hidden="true"
                                            />
                                        )}
                                    </th>
                                    <th
                                        style={{ whiteSpace: "nowrap" }}
                                        onClick={(e) =>
                                            this.sortData("approval_last_month")
                                        }
                                    >
                                        Approvals(Last Month)
                                        {sortBy === "approval_last_month" && (
                                            <i
                                                className={
                                                    sortValue === "ASC"
                                                        ? "fa fa-arrow-up"
                                                        : "fa fa-arrow-down"
                                                }
                                                aria-hidden="true"
                                            />
                                        )}
                                    </th>
                                    <th
                                        style={{ whiteSpace: "nowrap" }}
                                        onClick={(e) =>
                                            this.sortData(
                                                "approval_life_of_orgs",
                                            )
                                        }
                                    >
                                        Approvals(Life of Org)
                                        {sortBy === "approval_life_of_orgs" && (
                                            <i
                                                className={
                                                    sortValue === "ASC"
                                                        ? "fa fa-arrow-up"
                                                        : "fa fa-arrow-down"
                                                }
                                                aria-hidden="true"
                                            />
                                        )}
                                    </th>
                                    <th style={{ whiteSpace: "nowrap" }}>
                                        Main admin
                                    </th>
                                    <th
                                        style={{ whiteSpace: "nowrap" }}
                                        className="thRM"
                                    >
                                        Team Lead
                                    </th>
                                    <th style={{ whiteSpace: "nowrap" }}>
                                        Type
                                        <div className="relationship-select-area">
                                            <select
                                                className="relationship-select"
                                                onChange={(e) => {
                                                    this.setState(
                                                        {
                                                            type: e.target
                                                                .value,
                                                            typeFilterArrow:
                                                                !this.state
                                                                    .typeFilterArrow,
                                                            page: 1,
                                                        },
                                                        () => {
                                                            this.fetchOrgs();
                                                        },
                                                    );
                                                }}
                                            >
                                                {orgTypeOptions.map((item) => (
                                                    <option value={item.value}>
                                                        {" "}
                                                        {item.label}{" "}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {listOrganizations.length == 0 ? (
                                    <>
                                        {this.state.timeout > 0 ? (
                                            <p className="loader"></p>
                                        ) : (
                                            <tr>
                                                <td colSpan="12">
                                                    <h4 className="text-ceneter">
                                                        No record found!
                                                    </h4>
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                ) : (
                                    <OrganizationRowData
                                        isPcAdmin={isPcAdmin}
                                        user={user}
                                        addMember={(evt) => {
                                            this.setState({
                                                organization_id: evt,
                                                showAddMember: true,
                                            });
                                        }}
                                        confirmModel={(evt) => {
                                            this.setState({
                                                organization_id: evt,
                                                showConfirmModel: true,
                                            });
                                        }}
                                        listOrganizationUsers={
                                            this.props.listOrganizationUsers
                                        }
                                        onEditClick={(evt) =>
                                            this.props.onEditClick(evt)
                                        }
                                        listOrganizations={listOrganizations}
                                        addResidueModal={(evt) => {
                                            this.props.showAddResidueModal(evt);
                                        }}
                                    />
                                )}
                            </tbody>
                        </table>
                    </div>
                    <ReactPaginate
                        previousLabel={"previous"}
                        nextLabel={"next"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={Math.ceil(totalOrganization / 10)}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        activeClassName={"active"}
                        forcePage={this.state.page - 1}
                    />
                </div>
                <Dialog fullWidth open={is_modal}>
                    <DialogTitle>
                        <h5>Org. Member's Emails under TL: {filterRMName}</h5>
                    </DialogTitle>
                    <DialogContent dividers>
                        <textarea
                            ref={(textarea) => (this.textArea = textarea)}
                            style={{
                                wordBreak: "break-all",
                                width: "100%",
                                height: "250px",
                                border: "0 none",
                            }}
                            value={org_emails ? org_emails : "No Emails Found"}
                        />
                    </DialogContent>
                    <DialogActions>
                        {org_emails && (
                            <Button
                                onClick={(e) => this.copyToClipboard(e)}
                                color="primary"
                            >
                                Copy to Clipboard
                            </Button>
                        )}
                        <Button
                            onClick={() =>
                                this.setState({
                                    is_modal: false,
                                })
                            }
                            color="secondary"
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
export default OrganizationsPage;
